import { useCallback, useRef, useState } from 'react';

/**
 * Roving-tabindex nav over the transcript's timestamp buttons: one tab stop,
 * then Arrow keys move focus between rows. Focus lives on the real <button>
 * (not the row) to avoid nesting interactives (axe `nested-interactive`).
 */
export function useTranscriptKeyboardNav(totalRows: number) {
  const [activeIndex, setActiveIndex] = useState(0);
  const rowRefs = useRef<(HTMLButtonElement | null)[]>([]);

  const setRowRef = useCallback(
    (index: number) => (node: HTMLButtonElement | null) => {
      rowRefs.current[index] = node;
    },
    [],
  );

  const focusRow = useCallback(
    (index: number) => {
      if (totalRows === 0) return;
      const clamped = Math.max(0, Math.min(totalRows - 1, index));
      setActiveIndex(clamped);
      const node = rowRefs.current[clamped];
      node?.focus();
      node?.scrollIntoView?.({ block: 'nearest' });
    },
    [totalRows],
  );

  return { activeIndex, setActiveIndex, setRowRef, focusRow };
}
